import axios from "axios";

export default {
  async checkTokenValidity() {
    try {
      const response = await axios.post("/api/auth/checktoken");
      return response.data.isValid;
    } catch (error) {
      return false;
    }
  },

  getAuthToken() {
    const cookies = document.cookie.split(";");
    const tokenCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("auth_token=")
    );
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  },

  clearAuthToken() {
    document.cookie =
      "auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  },
};
